import React from 'react';
import noop from 'lodash/noop';
import { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { useIntl } from '@atlassian/jira-intl';
import { useProjectsAnalyticsL4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/controllers/use-projects-analytics-l4/index.tsx';
import {
	MOVE_UP,
	MOVE_DOWN,
	MOVE_TO_BOTTOM,
	MOVE_TO_TOP,
} from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/item-id.tsx';
import messages from '../messages.tsx';
import type { Props, AnalyticsItemId } from './types.tsx';

export function MoveInSidebarMenu({
	projectId,
	projectType,
	positionType = 'standard',
	onMoveToTop = noop,
	onMoveUp = noop,
	onMoveDown = noop,
	onMoveToBottom = noop,
}: Props) {
	const { formatMessage } = useIntl();
	const { sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent } = useProjectsAnalyticsL4();

	const sendActionAnalytics = (itemId: AnalyticsItemId) => {
		sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent({
			itemId,
			projectId,
			projectType,
			starred: true,
			recent: false,
		});
	};

	return (
		<DropdownItemGroup>
			<DropdownItem
				isDisabled={positionType === 'first'}
				onClick={() => {
					onMoveToTop();
					sendActionAnalytics(MOVE_TO_TOP);
				}}
			>
				{formatMessage(messages.moveToTop)}
			</DropdownItem>
			<DropdownItem
				isDisabled={positionType === 'first'}
				onClick={() => {
					onMoveUp();
					sendActionAnalytics(MOVE_UP);
				}}
			>
				{formatMessage(messages.moveUp)}
			</DropdownItem>
			<DropdownItem
				isDisabled={positionType === 'last'}
				onClick={() => {
					onMoveDown();
					sendActionAnalytics(MOVE_DOWN);
				}}
			>
				{formatMessage(messages.moveDown)}
			</DropdownItem>
			<DropdownItem
				isDisabled={positionType === 'last'}
				onClick={() => {
					onMoveToBottom();
					sendActionAnalytics(MOVE_TO_BOTTOM);
				}}
			>
				{formatMessage(messages.moveToBottom)}
			</DropdownItem>
		</DropdownItemGroup>
	);
}
